import { Observable } from 'rxjs';

import { CdmDeviceUiDevice } from './models/cdm-device-ui-device';

export abstract class CdmDeviceUiApiService {
	public abstract getDevice$(deviceId: string): Observable<CdmDeviceUiDevice>;
}
